export { MapAdditionalLogos } from './MapAdditionalLogos.component';
